module.exports = __webpack_public_path__ + "img/sy.26ddc444.svg";